import React, { useState, useEffect } from "react";
import styled from "styled-components";
import Button from "@material-ui/core/Button";
import sortBy from "lodash/sortBy";
import Dialog from "@material-ui/core/Dialog";

import { Flex, PromptHeader, PromptBody, PromptButton, Prompt } from "../styles/global";
import { getInterventions, deleteIntervention } from "../utils/api.utils";
import { InterventionEditor } from "../pages/InterventionEditor";
import { Intervention } from "../models";
import defaultIntervention from "../data/defaultIntervention";

export const InterventionList = () => {
  const [showEditScreen, setEditScreen] = useState(false);
  const [loading, setLoading] = useState(true);
  const [currentIntervention, setCurrentIntervention] = useState<any>();
  const [interventions, setInterventions] = useState<Intervention[]>([]);
  const [showDeleteModal, setShowDeleteModal] = useState(false);
  const deleteIcon = require("../assets/delete.svg");

  const fetchInterventions = () => {
    getInterventions()
      .then((result: any) => {
        setLoading(false)
        const payload = result as any;
        setInterventions(sortBy(payload, "created_at"));
      })
      .catch((err) => setInterventions([]));
  };

  const createNewIntervention = () => {
    setCurrentIntervention(defaultIntervention);
    setEditScreen(true);
  };

  const selectIntervention = (intervention: any) => {
    setCurrentIntervention(intervention);
    setEditScreen(true);
  };

  const handleInterventionDelete = (intervention: any) => {
    deleteIntervention(intervention.id)
      .then((res) => console.log(res))
      .catch((err) => console.error(err));
    setCurrentIntervention(undefined);
    setShowDeleteModal(false);
    // delay call to fetch simulation for deletion to appear.
    setTimeout(() => fetchInterventions(), 1000);
    fetchInterventions();
  };

  const displayDeleteModal = (intervention: any) => {
    if (!intervention) {
      return;
    }
    setCurrentIntervention(intervention);
    // show modal
    setShowDeleteModal(true);
  };

  useEffect(() => {
    fetchInterventions()
  }, []);

  if (showEditScreen) {
    window.scrollTo(0, 0);
    return (
      <InterventionEditor
        shouldDisplay={setEditScreen}
        fetchInterventions={fetchInterventions}
        intervention={currentIntervention}
      />
    );
  }
  return (
    <div>
      <Flex justify="space-between" alignItems="center">
        <div>
          Interventions
        </div>
        <Button variant="contained" color='primary' onClick={() => createNewIntervention()}>
          Add New
        </Button>
      </Flex>
      <div id="interventions-view">
        {!loading ?
          interventions && interventions.length >= 1 ?
            interventions.map((item: any) => (
              <ListItem
                key={item.id + item.name}
                direction="row"
                justify="space-between"
              >
                <PathogenPreview
                  onClick={() => selectIntervention(item)}
                >
                  <ListTitle>{item.name && item.name}</ListTitle>
                </PathogenPreview>
                <OptionContainer alignItems="center">
                  <PromptButton
                    onClick={() => displayDeleteModal(item)}
                  >
                    <img src={deleteIcon} style={{ height: 30 }} alt="delete" />
                  </PromptButton>
                </OptionContainer>
              </ListItem>
            ))
            :
            <NotFound>No Interventions Found</NotFound>
          :
          <NotFound>Loading...</NotFound>
        }
        <Dialog
          aria-labelledby="simple-dialog-title"
          open={showDeleteModal}
        >
          <Prompt direction="column" justify="center" alignItems="center">
            <PromptHeader>
              Are you sure that you would like to delete this intervention?
            </PromptHeader>
            <PromptBody>Deleting an intervention is irreversible.</PromptBody>
            <Flex>
              <PromptButton
                onClick={() => setShowDeleteModal(false)}
                variant="contained"
              >
                Return
              </PromptButton>
              <PromptButton
                textcolor={"white"}
                tint={"#c10000"}
                onClick={() => handleInterventionDelete(currentIntervention)}
                variant="contained"
              >
                Delete
              </PromptButton>
            </Flex>
          </Prompt>
        </Dialog>
      </div>
    </div>
  );
};

const ListTitle = styled.h4`
  font-weight: 600;
  padding-bottom: 8px;
  font-size: 24px;
`;

const NotFound = styled.h4`
  font-weight: 600;
  margin-top: 120px;
  font-size: 24px;
  text-align: center;
`;

const ListItem = styled(Flex)`
  margin-top: 20px;
  padding: 16px;
  background: #F8F8F8;
  color: #000;
  border: solid 1px #666;
  border-radius: 8px;
`;

const PathogenPreview = styled(Flex)`
  flex-direction: row;
  width: 100%;
  padding: 24px 24px;
  justify-content: space-between;
  p {
    display: block;
  }
`;

const OptionContainer = styled(Flex)`
  /* padding: 20px; */

  > ${PromptButton} {
    margin: 0 16px !important;
    height: 50px;
  }
`;